import { Link } from "react-router-dom"
import { useContext, useState, useEffect } from "react"
import { DateTime } from "luxon"

import { useQuery } from "@apollo/client"

import ParticipantSidebar from "../../components/sidebars/ParticipantSidebar"
import PageSidebarContent from "../../components/sidebars/PageSidebarContent"

import styles from "../../styles/CustomDataForms.module.css"

//Hooks
import useLabels from "../../hooks/useLabels"

// Loader
import LoaderMedium from "../../components/Loaders"

// Context
import { UserContext } from "../../context/userContext"

// helpers
import dataParser from "../../helpers/parseJsonData"

// queries
import GLOBALS_STATUS from "../../config/globalsStatus"
import _ from "lodash"
import { CUSTOM_FORM_BY_PARTICIPANT } from "./queries"

export default function HepABForm() {
  const [loading, setLoading] = useState(true)
  const [noForm, setNoForm] = useState(false)
  const [data, setData] = useState(null)
  const userCtx = useContext(UserContext)
  const [loadingLabels, labels] = useLabels(["hep_ab_form"])

  const ID_TEMPLATE = "hep_ab_form"

  const { refetch } = useQuery(CUSTOM_FORM_BY_PARTICIPANT, {
    variables: {
      participant_id: userCtx.participant_id,
      organization_id: userCtx.session.user.organization_id,
      participant_membership_id: userCtx.participant_membership_id,
      idTemplate: ID_TEMPLATE,
    },
    skip: !userCtx,
    onCompleted: async (data) => {
      if (data.customForm === null) {
        setNoForm(true)
        return setLoading(false)
      }
      const dataFormatted = dataParser(data.customForm.data)
      setData(dataFormatted[0])
      setLoading(false)
    },
  })

  useEffect(() => {
    setLoading(true)
    setData(null)
    setNoForm(false)
    refetch()
  }, [userCtx.current_participant_id, refetch])

  if (loading || loadingLabels) return <LoaderMedium />

  const handleData = () => {
    if (noForm) {
      return (
        <div>
          <h2>No {labels.hep_ab_form} found for current Participant.</h2>
          <ul className={styles.cta}>
            <li>
              {_.includes(
                GLOBALS_STATUS.ACTIVE_STATUS,
                userCtx.participant_membership_status
              ) ? (
                <Link to={`/form/${ID_TEMPLATE}/1/`} className="btn">
                  New {labels.hep_ab_form}
                </Link>
              ) : (
                ""
              )}
            </li>
          </ul>
        </div>
      )
    }
    return (
      <div>
        <div>
          <ul className={styles.cta}>
            <li>
              {_.includes(
                GLOBALS_STATUS.ACTIVE_STATUS,
                userCtx.participant_membership_status
              ) ? (
                <Link
                  to={`/form/${ID_TEMPLATE}/1/${data.idStamp}`}
                  className="btn"
                >
                  Update {labels.hep_ab_form}
                </Link>
              ) : (
                ""
              )}
            </li>
          </ul>
        </div>
        <br />
        <div className={styles.table}>
          <div className={styles.tableRow}>
            <div>Form Date: </div>
            <div>{DateTime.fromISO(data.form_date).toISODate()}</div>
          </div>
          <div className={styles.tableRow}>
            <div>Hepatitis A Vaccination Status: </div>
            <div>{data.vaccination_a}</div>
          </div>
          <div className={styles.tableRow}>
            <div>Hepatitis B Vaccination Status: </div>
            <div>{data.vaccination_b}</div>
          </div>
          <div className={styles.tableRow}>
            <div>Hepatitis B test date: </div>
            <div>{DateTime.fromISO(data.hep_test_b_date).toISODate()}</div>
          </div>
          <div className={styles.tableRow}>
            <div>Hepatitis B test result: </div>
            <div>{data.hep_test_b_antigen_result}</div>
          </div>
          <div className={styles.tableRow}>
            <div>How was the person linked to vaccination? </div>
            <div>{data.hep_hbv_link_vaccination}</div>
          </div>
          <div className={styles.tableRow}>
            <div>Person received HBV treatment?</div>
            <div>{data.hep_hbv_treatment}</div>
          </div>
          <div className={styles.tableRow}>
            <div>HBV medication date pick up</div>
            <div>
              {DateTime.fromISO(data.hep_hbv_medication_date).toISODate()}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <PageSidebarContent>
        <ParticipantSidebar />
      </PageSidebarContent>
      <div className="main-content">
        <h1 className={styles.title}> {labels.hep_ab_form}</h1>
        <div className={styles.contentWrapper}>{handleData()}</div>
      </div>
    </>
  )
}
